import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ViewWhereHouseProducts from "./viewWhereHouseProducts";
import {
  ViewWhereHouse
} from "../../../redux/services/WhereHouseService/wherehouse.Services";
function ViewWhereHouseData() {
  const [viewData, setViewData] = useState({});
  const { id } = useParams();
  const navigate = useNavigate();

  const fetchWhereHouse = async () => {
    try {
      const payload = {
        id: id
      }
      const res = await ViewWhereHouse(payload);
      setViewData(res?.data || {});
    }
    catch (error) {
      console.log(error)
    }
  }
  useEffect(() => {
  if (id) {
    fetchWhereHouse();
  }
}, [id]);
  const formatDate = (date) => {
    if (!date) return "-";

    return new Date(date)
      .toLocaleString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      })
      .replace(/\//g, "-")
      .replace(",", "");
  };

  return (
    <div className="main_page">
      <div className="card">
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h4>View WhereHouse</h4>
            <button
              className="add-btn"
              onClick={() => navigate(-1)}
            >
              Back
            </button>
          </div>
          
          <div className="row">

            <div className="col-md-6 mb-3">
              <label>Vendor Name</label>
              <input
                type="text"
                className="form-control"
                value={viewData?.user_id || "-"}
                disabled
              />
            </div>
            <div className="col-md-6 mb-3">
              <label>Warehouse Name</label>
              <input
                type="text"
                className="form-control"
                value={viewData?.warehouse_name || "-"}
                disabled
              />
            </div>

            <div className="col-md-6 mb-3">
              <label>Warehouse Code</label>
              <input
                type="text"
                className="form-control"
                value={viewData?.warehouse_code || "-"}
                disabled
              />
            </div>

            <div className="col-md-6 mb-3">
              <label>Manager Name</label>
              <input
                type="text"
                className="form-control"
                value={viewData?.manager_name || "-"}
                disabled
              />
            </div>

            <div className="col-md-6 mb-3">
              <label>Contact Number</label>
              <input
                type="text"
                className="form-control"
                value={viewData?.contact_number || "-"}
                disabled
              />
            </div>

            <div className="col-md-6 mb-3">
              <label>Address</label>
              <textarea
                className="form-control"
                rows="3"
                value={viewData?.address || "-"}
                disabled
              />
            </div>

            <div className="col-md-6 mb-3">
              <label>Status</label>
              <input
                type="text"
                className="form-control"
                value={viewData?.status === 1 ? "Active" : "Inactive"}
                disabled
              />
            </div>

            <div className="col-md-6 mb-3">
              <label>Created At</label>
              <input
                type="text"
                className="form-control"
                value={formatDate(viewData?.created_at)}
                disabled
              />
            </div>

            <div className="col-md-6 mb-3">
              <label>Updated At</label>
              <input
                type="text"
                className="form-control"
                value={formatDate(viewData?.updated_at)}
                disabled
              />
            </div>

          </div>
          <ViewWhereHouseProducts warehouseId={viewData?.id} />
        </div>
      </div>
    </div>
  );
}

export default ViewWhereHouseData;